import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  MenuItem,
  Select,
  Stack,
  SvgIcon,
  Switch,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
  InputAdornment,
  Autocomplete,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Chip,
  FormGroup,
  Alert,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputLabel,
  ListItem,
  Tabs,
  Tab,
  alpha,
  List,
  ListItemText,
  CircularProgress,
  Pagination,
  Checkbox,
  Tooltip,
  useTheme,
  Link,
} from "@mui/material";
import CsvImport from "./csvImport";
//import ManualImport from "./manualImport";
import {
  CloseOutlined,
  ArrowRight,
  ArrowLeft,
  UploadFileOutlined,
  EmailOutlined,
  SearchOutlined,
  ReportProblemOutlined,
  DeleteOutlineOutlined,
  DownloadOutlined,
  VisibilityOutlined,
  Check,
} from "@mui/icons-material";
import axios from "axios";
import { API_SERVICE_BACKEND, HELP_URL } from "src/config";
import { toast } from "react-hot-toast";
import { CheckCircleIcon } from "src/assets/general/CheckCircleIcon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import moment from "moment";
import { formatToLocalDate } from "src/utils/format-to-local-date";
import { Scrollbar } from "src/components/scrollbar";
import { storageConfigs } from "src/storageConfig";
import { downloadBlobFile } from "src/utils/getBlobUrl";
import HelperLink from "src/components/HelperLink";

const scrollBarStyle = {
  "&::-webkit-scrollbar": {
    width: "14px",
    height: "14px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "60px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#E4E4E5",
    borderRadius: "10px",
    border: "4px solid rgba(0, 0, 0, 0)",
    backgroundClip: "padding-box",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#d5d5d5",
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      style={{ height: "100%" }}
    >
      {value === index && (
        <Box
          sx={{
            height: "100%",
            //overflow: "auto",
            overflow: "hidden",
            ...scrollBarStyle,
            my: 0.5,

          }}
        >
          <Box sx={{ height: "100%" }}>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ControlledInput = ({ label, search, setSearch, setPage, value }) => {
  const [state, setState] = useState(search);
  const debouncedSearchTerm = useDebouncedValue(state, 500);
  useEffect(() => {
    setSearch(debouncedSearchTerm);
    setPage(1);
  }, [debouncedSearchTerm]);
  useEffect(() => {
    setState(search);
  }, [value]);
  return (
    <TextField
      placeholder={label}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchOutlined sx={{ ml: "5px", color: theme => theme.palette.text.primary, }} />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      sx={{
        width: { xs: "80%", md: 300 },
        height: 40,
        "& div": { pl: 0.3 },
        "& div fieldset": {
          borderRadius: "8px",
          border: "1px solid #E4E4E5",
        },
        "& div input": {
          py: 1.3,
          fontSize: "13px",
          fontWeight: 400,
          lineHeight: "16px",
          letterSpacing: "0em",
          "&::placeholder": {
            color: theme => theme.palette.text.primary,
          },
        },
      }}
      value={state}
      onChange={(e) => {
        setState(e.target.value);
      }}
      className="glass-input"
    />
  );
};

const BlackListPanel = ({
  data,
  isLoading,
  value,
  selected,
  setSelected,
  isSelectAllEnabled,
  setIsSelectAllEnabled,
}) => {
  //console.log("data987", data)
  const handleSelect = (e, selected, setSelected) => {
    if (e.target.checked) {
      setSelected([...selected, e.target.value]);
    } else {
      const filtered = selected.filter((item) => item !== e.target.value);
      setSelected(filtered);
    }
  };
  const handleSelectAll = (e) => {
    setIsSelectAllEnabled(e.target.checked);
    setSelected([]);
  };
  return (
    <Box sx={{ height: "calc(100% - 40px)", overflow: "auto" }}>
      {isLoading ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : data && data?.length > 0 ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Checkbox
              value={"all"}
              checked={isSelectAllEnabled}
              onChange={handleSelectAll}
            />
            <Typography sx={{ fontSize: "14px", fontWeight: 500, color: theme => theme.palette.text.primary }}>
              Select All
            </Typography>
          </Box>
          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "", overflowX: "hidden", p: 0 }}
          >
            {data?.map((item) => {
              const labelId = `checkbox-list-label-${item}`;

              return (
                <ListItem key={item} disablePadding>
                  <Checkbox
                    value={item?.value}
                    checked={
                      selected?.includes(item?.value) || isSelectAllEnabled
                    }
                    disabled={isSelectAllEnabled}
                    onChange={(e) => handleSelect(e, selected, setSelected)}
                  />
                  <ListItemText
                    id={labelId}
                    sx={{ "& .MuiTypography-root": { fontSize: "14px", color: theme => theme.palette.text.primary } }}
                  >
                    {item?.value}
                  </ListItemText>
                </ListItem>
              );
            })}
          </List>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: "500", color: theme => theme.palette.text.primary }}>
            No {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

const BlackListFilesPanel = ({
  isLoading,
  data,
  value,
  setSelectedFileViewName,
  selectedFileViewName,
  setSelectedFileViewData,
  fetchBlackListedData,
  userEmail
}) => {

  function parseFileInfo(url) {
    // Extract the file name from the URL
    const decodedFileName = decodeURIComponent(
      url?.split("/")?.pop()?.split("?")?.[0] || ''
    );

    // Parse the file name
    const parts = decodedFileName.split("_");
    const parsedFileName = parts.slice(2).join("_");
    const date = parts[1] || new Date().toISOString();


    // Format the date
    const parsedDate = formatToLocalDate(date);

    // Get the timezone
    const getTimeZone = () => {
      const intl = Intl.DateTimeFormat().resolvedOptions().timeZone;
      moment.tz(intl).zoneName(); // This line doesn't do anything, kept for consistency with original code
      return moment.tz(intl).zoneAbbr();
    };

    // Combine date and timezone
    const formattedDate = `${parsedDate} ${getTimeZone()}`;

    return {
      fileName: parsedFileName,
      uploadDate: formattedDate,
    };
  }

  function extractFileInfo(url) {
    // Create a URL object
    const urlObj = new URL(url);

    // Extract the path
    const path = urlObj.pathname;

    // Use regex to extract the file name with timestamp
    const fileNameMatch = path.match(/\/([^\/]+)$/);
    const fullFileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : null;

    if (!fullFileName) {
      return {
        fileName: null,
        uploadDate: null,
      };
    }

    const isoDatePattern = /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)/;
    const timestampMatch = fullFileName.match(isoDatePattern);
    const timestamp = timestampMatch ? timestampMatch[1] : null;

    let fileName = null;
    if (timestamp) {
      const timestampIndex = fullFileName.indexOf(timestamp);
      const afterTimestamp = fullFileName.substring(timestampIndex + timestamp.length);
      const cleanedAfterTimestamp = afterTimestamp.startsWith("_")
        ? afterTimestamp.substring(1)
        : afterTimestamp;
      const parts = cleanedAfterTimestamp.split("_").filter(p => p.length > 0);
      if (parts.length > 1) {
        const firstPart = parts[0];
        const firstPartSegments = firstPart.split("-");
        const filenameStart = firstPartSegments.length > 1
          ? firstPartSegments.slice(1).join("-")
          : "";

        const remainingParts = parts.slice(1);
        if (filenameStart) {
          fileName = [filenameStart, ...remainingParts].join("_");
        } else {
          fileName = remainingParts.join("_");
        }
      } else if (parts.length === 1) {
        const firstPart = parts[0];
        const firstPartSegments = firstPart.split("-");
        fileName = firstPartSegments.length > 1
          ? firstPartSegments.slice(1).join("-")
          : firstPart || null;
      }
    } else {
      const parts = fullFileName.split("_");
      fileName = parts.slice(1).join("_") || fullFileName;
    }

    const formattedDate = formatDate(timestamp);

    return {
      fileName: fileName || null,
      uploadDate: formattedDate
    };
  }

  function formatDate(timestamp) {
    if (!timestamp) return "Date not available";

    const date = moment(timestamp);

    if (!date.isValid()) {
      return "Date not available";
    }

    const parsedDate = date.format("MMMM DD YYYY, h:mm a");

    const getTimeZone = () => {
      const intl = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment.tz(intl).zoneAbbr();
    };

    return `${parsedDate} ${getTimeZone()}`;
  }

  const exportCSVFile = async (fileName) => {
    const type = value === 1 ? "domains" : value === 2 ? "phones" : value === 3 ? "linkedins" : "emails";
    try {
      fetchBlackListedData(type, fileName, true);
      // handleDownloadCSVFile();
    } catch (error) {
      console.error("Error while fetching data:", error);
    }
  };


  return (
    <Box sx={{ height: "100%" }}>

      {/* <Stack
        direction="row"
        justifyContent="end"
        onClick={() => setSelectedFileViewName("All")}
      >
        <Button variant="contained" sx={{ fontSize: '14px' }}>
          View All {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : "Emails"}
        </Button>
      </Stack> */}

      {isLoading ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : data && data?.length > 0 ? (
        <List sx={{ width: "100%", overflowX: "hidden", p: 0 }} >
          {data?.filter(item => item?.url).map((item, index) => {
            const labelId = `checkbox-list-label-${index}`;
            // const decodedFileName = decodeURIComponent(
            //   item?.url?.split("/")?.pop()?.split("?")?.[0]
            // );
            // const fileName = decodedFileName
            //   ?.split("_")
            //   .slice(2)
            //   .join("_");
            // const date = decodedFileName?.split("_")?.[1] || new Date();
            // const getTimeZone = () => {
            //   const intl = Intl.DateTimeFormat().resolvedOptions().timeZone; // Asia/Tokyo
            //   moment.tz(intl).zoneName(); // JST
            //   return moment.tz(intl).zoneAbbr();
            // };
            // const uploadDate = `${moment(date).format("MMMM DD YYYY, h:mm a")} ${getTimeZone()}`;
            let fileName;
            let fullFileName;
            let uploadDate;

            if (!item?.url) {
              return null;
            }

            if (item.url.includes("s3.wasabisys.com")) {
              const fileInfo = parseFileInfo(item?.url);
              fileName = fileInfo.fileName;
              uploadDate = fileInfo.uploadDate;
              // Extract full filename from URL for backend
              const urlObj = new URL(item?.url);
              const path = urlObj.pathname;
              const fileNameMatch = path.match(/\/([^\/]+)$/);
              fullFileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : fileName;
            } else {
              const fileInfo = extractFileInfo(item?.url);
              fileName = fileInfo.fileName;
              uploadDate = fileInfo.uploadDate;
              // Extract full filename from URL for backend
              const urlObj = new URL(item?.url);
              const path = urlObj.pathname;
              const fileNameMatch = path.match(/\/([^\/]+)$/);
              fullFileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : fileName;
            }
            return (
              <ListItem
                key={index}
                disablePadding
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: 1,
                  border: `1px solid ${alpha("#000000", 0.05)}`,
                  p: 1,
                  my: 1,
                  mt: index === 0 ? 0 : 1,
                  gap: 2,
                  marginLeft: "4px"
                }}
                className="glass-wrapper-25"
              >
                <ListItemText sx={{ width: "30%", "& .MuiTypography-root": { fontSize: "14px", color: theme => theme.palette.text.primary } }} id={labelId}>
                  {fileName || ""}
                </ListItemText>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 1,
                    width: "35%",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography sx={{ fontSize: "14px", color: theme => theme.palette.text.primary }}>
                    Uploaded On :
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500", color: theme => theme.palette.text.primary }}>
                    {uploadDate}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 1,
                    width: "25%",
                  }}
                >
                  {item?.processed && item?.status === "completed" && (
                    <Tooltip
                      title={`${item?.lastProcessedRow} ${item?.lastProcessedRow > 1
                        ? value === 1
                          ? "domains have"
                          : value === 2
                            ? "phone numbers have"
                            : value === 3
                              ? "linkedin profiles have"
                              : "emails have"
                        : value === 1
                          ? "domain has"
                          : value === 2
                            ? "phone number has"
                            : value === 3
                              ? "linkedin profile has"
                              : "email has"
                        } been added!`}
                      placement="top"
                      arrow
                    >
                      <IconButton
                        sx={{
                          backgroundColor: "success.main",
                          width: 25,
                          height: 25,
                          "&:hover": {
                            backgroundColor: "success.dark",
                          }
                        }}
                      >
                        <Check sx={{ color: "#fff", fontSize: "18px" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {/* <Tooltip title="Delete" placement="top" arrow>
                    <IconButton
                      sx={{
                        color: "#050C46",
                      }}
                    >
                      <DeleteOutlineOutlined />
                    </IconButton>
                  </Tooltip> */}
                  <Tooltip
                    title="Download"
                    placement="top"
                    arrow
                  >
                    <IconButton
                      onClick={async () => {
                        if (!item?.url) {
                          toast.error("File URL is not available");
                          return;
                        }

                        let downloadUrl = item.url;
                        const hasSasToken = downloadUrl.includes("?") && (downloadUrl.includes("sig=") || downloadUrl.includes("se="));

                        if (!hasSasToken && downloadUrl.includes("blob.core.windows.net")) {
                          // Determine which SAS token to use
                          // value === 0 -> emails, value === 1 -> domains
                          const configKey = value === 0 ? "emails" : value === 2 ? "phones" : value === 3 ? "linkedins" : "domains";
                          const config = storageConfigs[configKey];

                          if (config?.sasToken) {
                            const separator = downloadUrl.includes("?") ? "&" : "?";
                            downloadUrl = `${downloadUrl}${separator}${config.sasToken}`;
                          }
                        }

                        const downloadFileName = fileName || fullFileName || "download.csv";

                        try {
                          await downloadBlobFile(downloadUrl, downloadFileName);
                        } catch (error) {
                          console.error("Download error:", error);
                          toast.error("Failed to download file. Please try again.");
                        }
                      }}
                      sx={{
                        color: theme => theme.palette.text.primary,
                      }}
                    >
                      <DownloadOutlined />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={`View ${value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}`}
                    placement="top"
                    arrow
                  >
                    <IconButton
                      onClick={() => { setSelectedFileViewName(fullFileName); setSelectedFileViewData(true); }}
                      sx={{
                        color: theme => theme.palette.text.primary,
                      }}
                    >
                      <VisibilityOutlined />
                    </IconButton>
                  </Tooltip>
                </Box>
              </ListItem>
            );
          })}
          <ListItem
            disablePadding
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: 1,
              marginLeft: "4px",
              border: `1px solid ${alpha("#000000", 0.05)}`,
              p: 1,
              my: 1,
              mt: 1,
              gap: 2,
            }}
            className="glass-wrapper-25"
          >
            <ListItemText sx={{ width: "30%", "& .MuiTypography-root": { fontSize: "14px", color: theme => theme.palette.text.primary } }}>Others</ListItemText>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
                width: "25%",
              }}
            >
              <Tooltip
                title={`View ${value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}`}
                placement="top"
                arrow
              >
                <IconButton
                  onClick={() => {
                    setSelectedFileViewName("other");
                    setSelectedFileViewData(true);
                  }}
                  sx={{
                    color: theme => theme.palette.text.primary,
                  }}
                >
                  <VisibilityOutlined />
                </IconButton>
              </Tooltip>
            </Box>
          </ListItem>
        </List>
      ) : (
        <List sx={{ width: "100%" }}>
          <ListItem
            disablePadding
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: 1,
              border: `1px solid ${alpha("#000000", 0.05)}`,
              p: 1,
              my: 1,
              mt: 1,
              gap: 2,
              marginLeft: "4px"

            }}
            className="glass-wrapper-25"
          >
            <ListItemText sx={{ width: "30%" }}>Others</ListItemText>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
                width: "25%",
              }}
            >
              <Tooltip
                title={`View ${value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}`}
                placement="top"
                arrow
              >
                <IconButton
                  onClick={() => {
                    setSelectedFileViewName("other");
                    setSelectedFileViewData(true);
                  }}
                  sx={{
                    color: theme => theme.palette.text.primary,
                  }}
                >
                  <VisibilityOutlined />
                </IconButton>
              </Tooltip>
            </Box>
          </ListItem>
        </List>
      )}
    </Box>
  );
};

const useDebouncedValue = (inputValue, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue, delay]);

  return debouncedValue;
};

const PhoneFilesPanel = ({ isLoading, data, setSelectedFileViewName, setSelectedFileViewData, setPage, fetchBlackListedData, type, typeName }) => {
  if (isLoading) {
    return (
      <Box sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  const namedFiles = (data || []).filter(g => g.fileName !== null);
  const othersGroup = (data || []).find(g => g.fileName === null);

  const renderIcons = (fileViewName, total) => (
    <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, width: "25%" }}>
      {total > 0 && (
        <Tooltip title={`${total} ${total > 1 ? `${typeName} have` : `${typeName} has`} been added!`} placement="top" arrow>
          <IconButton sx={{ backgroundColor: "success.main", width: 25, height: 25, "&:hover": { backgroundColor: "success.dark" } }}>
            <Check sx={{ color: "#fff", fontSize: "18px" }} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Download" placement="top" arrow>
        <IconButton
          onClick={() => fetchBlackListedData(type, fileViewName, true)}
          sx={{ color: theme => theme.palette.text.primary }}
        >
          <DownloadOutlined />
        </IconButton>
      </Tooltip>
      <Tooltip title={`View ${typeName}`} placement="top" arrow>
        <IconButton
          onClick={() => { setPage(1); setSelectedFileViewName(fileViewName); setSelectedFileViewData(true); }}
          sx={{ color: theme => theme.palette.text.primary }}
        >
          <VisibilityOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  );

  return (
    <Box sx={{ height: "100%" }}>
      <List sx={{ width: "100%", overflowX: "hidden", p: 0 }}>
        {namedFiles.map((group, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: 1,
              border: `1px solid ${alpha("#000000", 0.05)}`,
              p: 1,
              my: 1,
              mt: index === 0 ? 0 : 1,
              gap: 2,
              marginLeft: "4px",
            }}
            className="glass-wrapper-25"
          >
            <ListItemText sx={{ width: "40%", "& .MuiTypography-root": { fontSize: "14px", color: theme => theme.palette.text.primary } }}>
              {group.fileName}
            </ListItemText>
            {renderIcons(group.fileName, group.total)}
          </ListItem>
        ))}

        <ListItem
          disablePadding
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 1,
            border: `1px solid ${alpha("#000000", 0.05)}`,
            p: 1,
            my: 1,
            mt: namedFiles.length === 0 ? 0 : 1,
            gap: 2,
            marginLeft: "4px",
          }}
          className="glass-wrapper-25"
        >
          <ListItemText sx={{ width: "40%", "& .MuiTypography-root": { fontSize: "14px", color: theme => theme.palette.text.primary } }}>
            Others
          </ListItemText>
          {renderIcons("other", othersGroup?.total || 0)}
        </ListItem>
      </List>
    </Box>
  );
};

const BlackList = ({ userEmail }) => {
  const [value, setValue] = useState(0);
  const [blockedEmails, setBlockedEmails] = useState({});
  const [blockedDomains, setBlockedDomains] = useState({});
  const [blockedPhones, setBlockedPhones] = useState({});
  const [searchEmail, setSearchEmail] = useState("");
  const [searchDomain, setSearchDomain] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [searchLinkedIn, setSearchLinkedIn] = useState("");
  const [selectedDomains, setSelectedDomains] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedPhones, setSelectedPhones] = useState([]);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isSelectAllEmailsEnabled, setIsSelectAllEmailsEnabled] =
    useState(false);
  const [isSelectAllDomainsEnabled, setIsSelectAllDomainsEnabled] =
    useState(false);
  const [isSelectAllPhonesEnabled, setIsSelectAllPhonesEnabled] =
    useState(false);
  const [selectedLinkedIns, setSelectedLinkedIns] = useState([]);
  const [isSelectAllLinkedInsEnabled, setIsSelectAllLinkedInsEnabled] = useState(false);
  const [blockedLinkedIns, setBlockedLinkedIns] = useState({});
  const [selectedFileViewName, setSelectedFileViewName] = useState("");
  const [fileName, setFileName] = useState("");
  const [selectedFileViewData, setSelectedFileViewData] = useState(false);

  const activeSelectedData = value === 1 ? selectedDomains : value === 2 ? selectedPhones : value === 3 ? selectedLinkedIns : selectedEmails;
  const activeTab = value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn" : "Emails";

  // const debouncedEmailSearchTerm = useDebouncedValue(searchEmail, 500);
  // const debouncedDomainSearchTerm = useDebouncedValue(searchDomain, 500);

  const handleClickOpen = () => {
    setIsDeleteOpen(true);
  };

  const handleClose = () => {
    setIsDeleteOpen(false);
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);

      if (value === 2) {
        // Phones: use dedicated delete API with _id array
        const ids = isSelectAllPhonesEnabled
          ? allPhoneNumbers.map(n => n._id)
          : allPhoneNumbers.filter(n => selectedPhones.includes(n.value)).map(n => n._id);

        await axios.delete(
          `${API_SERVICE_BACKEND}/exclusionlist/deleteNumbersFromBlockList`,
          { data: { clientEmail: userEmail, ids } }
        );
        setIsDeleting(false);
        setIsDeleteOpen(false);
        setSelectedPhones([]);
        setIsSelectAllPhonesEnabled(false);
        fetchBlackListedData("phones", selectedFileViewName);
        toast.success("Successfully deleted!");
        return;
      }

      if (value === 3) {
        const ids = isSelectAllLinkedInsEnabled
          ? allLinkedInProfiles.map(n => n._id)
          : allLinkedInProfiles.filter(n => selectedLinkedIns.includes(n.value)).map(n => n._id);
        await axios.delete(
          `${API_SERVICE_BACKEND}/exclusionlist/deleteNumbersFromBlockList`,
          { data: { clientEmail: userEmail, ids } }
        );
        setIsDeleting(false);
        setIsDeleteOpen(false);
        setSelectedLinkedIns([]);
        setIsSelectAllLinkedInsEnabled(false);
        fetchBlackListedData("linkedins", selectedFileViewName);
        toast.success("Successfully deleted!");
        return;
      }

      // Emails / Domains
      const body =
        value === 0
          ? {
            clientEmail: userEmail,
            removeEmails: isSelectAllEmailsEnabled
              ? blockedEmails?.data?.map(item => item.value) || []
              : selectedEmails,
          }
          : {
            clientEmail: userEmail,
            removeDomains: isSelectAllDomainsEnabled
              ? blockedDomains?.data?.map(item => item.value) || []
              : selectedDomains,
          };

      await axios.put(`${API_SERVICE_BACKEND}/exclusionlist/updateExclusionList`, body);
      setIsDeleting(false);
      setIsDeleteOpen(false);
      fetchBlackListedData(value === 1 ? "domains" : "emails", selectedFileViewName);
      if (value === 1) {
        setSelectedDomains([]);
        setIsSelectAllDomainsEnabled(false);
      } else {
        setSelectedEmails([]);
        setIsSelectAllEmailsEnabled(false);
      }
      toast.success("Successfully deleted!");
    } catch (error) {
      setIsDeleting(false);
      console.error("Error during deletion:", error);
      toast.error("Something went wrong!");
    }
  };

  const handleClear = () => {
    if (value === 0) {
      setSelectedEmails([]);
      setIsSelectAllEmailsEnabled(false);
    }
    if (value === 1) {
      setSelectedDomains([]);
      setIsSelectAllDomainsEnabled(false);
    }
    if (value === 2) {
      setSelectedPhones([]);
      setIsSelectAllPhonesEnabled(false);
    }
    if (value === 3) {
      setSelectedLinkedIns([]);
      setIsSelectAllLinkedInsEnabled(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(1);
  };
  const [isImportLeadsDialogOpen, setIsImportLeadsDialogOpen] = useState(false);

  const handleClickOpenImportLeadsDialog = () => {
    setIsImportLeadsDialogOpen(true);
  };

  const handleCloseOpenImportLeadsDialog = () => {
    setIsImportLeadsDialogOpen(false);
    setActiveStep(0);
    setFileInputKey(Date.now());
  };

  const [emailFiles, setEmailFiles] = useState([]);
  const [domainFiles, setDomainFiles] = useState([]);
  const [phoneFiles, setPhoneFiles] = useState([]);
  const [allPhoneNumbers, setAllPhoneNumbers] = useState([]);
  const [linkedInFiles, setLinkedInFiles] = useState([]);
  const [allLinkedInProfiles, setAllLinkedInProfiles] = useState([]);

  const [activeStep, setActiveStep] = useState(0);
  const [selectedEmailFile, setSelectedEmailFile] = useState(null);
  const [selectedDomainFile, setSelectedDomainFile] = useState(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const theme = useTheme();
  const handlePageChange = (e, value) => {
    setPage(value);
  };
  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };
  let abortController = new AbortController();
  const fetchBlackListedData = async (type, selectedFileViewName, isData = false) => {
    const meta = selectedFileViewName === undefined ? true : false;

    setIsLoading(true);

    // ── Phones: dedicated API, all records fetched client-side ───────────────
    if (type === "phones") {
      try {
        const FETCH_LIMIT = 500; // API max per call

        if (meta) {
          // Files panel: get group summaries from getNumberBlockList
          const url = `${API_SERVICE_BACKEND}/exclusionlist/getNumberBlockList?clientEmail=${encodeURIComponent(userEmail)}&targetType=PHONE&page=1&limit=1`;
          const res = await axios.get(url, { signal: abortController?.signal });
          const groups = res?.data?.data || [];
          setPhoneFiles(groups.map(g => ({ fileName: g.fileName, total: g.total })));
        } else {
          // Detail view: fetch ALL numbers for the selected group
          const targetFileName = selectedFileViewName === "other" ? null : selectedFileViewName === "All" ? null : selectedFileViewName;
          let allNums = [];
          let fetchPage = 1;
          let totalCount = Infinity;

          const isViewAll = selectedFileViewName === "All";

          while (allNums.length < totalCount) {
            const url = `${API_SERVICE_BACKEND}/exclusionlist/getNumberBlockList?clientEmail=${encodeURIComponent(userEmail)}&targetType=PHONE&page=${fetchPage}&limit=${FETCH_LIMIT}&search=${encodeURIComponent(searchPhone || "")}`;
            const res = await axios.get(url, { signal: abortController?.signal });
            const groups = res?.data?.data || [];

            if (isViewAll) {
              // Combine all groups
              if (fetchPage === 1) totalCount = groups.reduce((sum, g) => sum + g.total, 0);
              const batch = groups.flatMap(g => g.numbers || []);
              allNums = [...allNums, ...batch];
              if (batch.length < FETCH_LIMIT || allNums.length >= totalCount) break;
            } else {
              const group = groups.find(g => g.fileName === targetFileName) || { numbers: [], total: 0 };
              if (fetchPage === 1) totalCount = group.total;
              const batch = group.numbers || [];
              allNums = [...allNums, ...batch];
              if (batch.length < FETCH_LIMIT || allNums.length >= totalCount) break;
            }
            fetchPage++;
          }

          const mappedNums = allNums.map(n => ({ value: n.target, _id: n._id, createdAt: "" }));
          if (isData) {
            handleDownloadCSVFile({ data: mappedNums, total: mappedNums.length }, selectedFileViewName);
          } else {
            setAllPhoneNumbers(mappedNums);
          }
        }
      } catch (error) {
        //console.log("phones error", error);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    // ── LinkedIn: dedicated API, all records fetched client-side ─────────────
    if (type === "linkedins") {
      try {
        const FETCH_LIMIT = 500;

        if (meta) {
          const url = `${API_SERVICE_BACKEND}/exclusionlist/getNumberBlockList?clientEmail=${encodeURIComponent(userEmail)}&targetType=LINKEDIN&page=1&limit=1`;
          const res = await axios.get(url, { signal: abortController?.signal });
          const groups = res?.data?.data || [];
          setLinkedInFiles(groups.map(g => ({ fileName: g.fileName, total: g.total })));
        } else {
          const targetFileName = selectedFileViewName === "other" ? null : selectedFileViewName === "All" ? null : selectedFileViewName;
          let allProfiles = [];
          let fetchPage = 1;
          let totalCount = Infinity;

          const isViewAll = selectedFileViewName === "All";

          while (allProfiles.length < totalCount) {
            const url = `${API_SERVICE_BACKEND}/exclusionlist/getNumberBlockList?clientEmail=${encodeURIComponent(userEmail)}&targetType=LINKEDIN&page=${fetchPage}&limit=${FETCH_LIMIT}&search=${encodeURIComponent(searchLinkedIn || "")}`;
            const res = await axios.get(url, { signal: abortController?.signal });
            const groups = res?.data?.data || [];

            if (isViewAll) {
              if (fetchPage === 1) totalCount = groups.reduce((sum, g) => sum + g.total, 0);
              const batch = groups.flatMap(g => g.numbers || []);
              allProfiles = [...allProfiles, ...batch];
              if (batch.length < FETCH_LIMIT || allProfiles.length >= totalCount) break;
            } else {
              const group = groups.find(g => g.fileName === targetFileName) || { numbers: [], total: 0 };
              if (fetchPage === 1) totalCount = group.total;
              const batch = group.numbers || [];
              allProfiles = [...allProfiles, ...batch];
              if (batch.length < FETCH_LIMIT || allProfiles.length >= totalCount) break;
            }
            fetchPage++;
          }

          const mappedProfiles = allProfiles.map(n => ({ value: n.target, _id: n._id, createdAt: "" }));
          if (isData) {
            handleDownloadCSVFile({ data: mappedProfiles, total: mappedProfiles.length }, selectedFileViewName);
          } else {
            setAllLinkedInProfiles(mappedProfiles);
          }
        }
      } catch (error) {
        //console.log("linkedins error", error);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    // ── Emails / Domains: existing API ───────────────────────────────────────
    const search = value === 1 ? searchDomain : searchEmail;
    const fileName =
      selectedFileViewName === undefined
        ? false
        : selectedFileViewName === "All"
          ? ""
          : selectedFileViewName;

    try {
      const encodedFileName = fileName ? encodeURIComponent(fileName) : fileName;
      const apiUrl = `${API_SERVICE_BACKEND}/exclusionlist/getExclusionLists?clientEmail=${encodeURIComponent(userEmail)}&meta=${meta}&listType=${type}&fileName=${encodedFileName}&page=${page}&limit=${limit}&search=${encodeURIComponent(search || "")}`;
      const response = await axios.get(apiUrl, { signal: abortController?.signal });

      if (type === "emails") {
        if (!meta) {
          let emails = [];
          let emailsTotal = 0;
          if (response?.data?.success && Array.isArray(response?.data?.data)) {
            emails = response.data.data.map((item) => {
              let value = item.Email || item.value || item.email;
              if (!value) {
                const values = Object.values(item);
                if (values.length > 0) value = values[0];
              }
              return { ...item, value, createdAt: item.createdAt || new Date().toISOString() };
            });
            emailsTotal = response.data.rows || 0;
          } else {
            emails = response?.data?.[0]?.emails || [];
            emailsTotal = response?.data?.[0]?.emailsTotal || 0;
          }
          const data = { data: emails, total: emailsTotal };
          setBlockedEmails(data);
          if (isData) handleDownloadCSVFile(data, selectedFileViewName);
        } else {
          const emailData = response?.data?.[0]?.uploadedExclusionList?.filter(
            (item) => item.operation === "addEmails"
          );
          setEmailFiles(emailData);
        }
      }

      if (type === "domains") {
        if (!meta) {
          let domains = [];
          let domainsTotal = 0;
          if (response?.data?.success && Array.isArray(response?.data?.data)) {
            domains = response.data.data.map((item) => {
              let value = item.Domain || item.value || item.domain;
              if (!value) {
                const values = Object.values(item);
                if (values.length > 0) value = values[0];
              }
              return { ...item, value, createdAt: item.createdAt || new Date().toISOString() };
            });
            domainsTotal = response.data.rows || 0;
          } else {
            domains = response?.data?.[0]?.domains || [];
            domainsTotal = response?.data?.[0]?.domainsTotal || 0;
          }
          const data = { data: domains, total: domainsTotal };
          setBlockedDomains(data);
          if (isData) handleDownloadCSVFile(data, selectedFileViewName);
        } else {
          const domainData = response?.data?.[0]?.uploadedExclusionList?.filter(
            (item) => item.operation === "addDomains"
          );
          setDomainFiles(domainData);
        }
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownloadCSVFile = (data, selectedFileViewName) => {
    if (!data?.data || data.data.length === 0) {
      toast.error("File is empty - no data to download");
      return;
    }

    let csvHeader = "";
    let csvRows = "";

    if (value === 0) {
      csvHeader = "Email,Created_Date\n";

      csvRows = data.data.reduce((acc, item, index) => {
        const row = `"${item?.value}","${item?.createdAt}"`;
        return acc + row + (index < data.data.length - 1 ? "\r\n" : "");
      }, "");

    } else if (value === 1) {
      csvHeader = "Domain,Created_Date\n";

      csvRows = data.data.reduce((acc, item, index) => {
        const row = `"${item?.value}","${item?.createdAt}"`;
        return acc + row + (index < data.data.length - 1 ? "\r\n" : "");
      }, "");
    } else if (value === 2) {
      csvHeader = "";

      csvRows = data.data.map(item => item?.value || "").join("\r\n");
    } else if (value === 3) {
      csvHeader = "";
      csvRows = data.data.map(item => item?.value || "").join("\r\n");
    }

    const csvContent = csvHeader + csvRows;
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${selectedFileViewName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Emails & Domains — re-fetch on page/limit/search changes (server-side pagination)
  useEffect(() => {
    if (value === 2 || value === 3) return;
    abortController?.abort();
    abortController = new AbortController();

    if (value === 0) {
      if (selectedFileViewName) {
        fetchBlackListedData("emails", selectedFileViewName);
      } else {
        fetchBlackListedData("emails");
      }
    }
    if (value === 1) {
      if (selectedFileViewName) {
        fetchBlackListedData("domains", selectedFileViewName);
      } else {
        fetchBlackListedData("domains");
      }
    }
    return () => {
      abortController.abort();
    };
  }, [value, page, limit, searchDomain, searchEmail, selectedFileViewName]);

  // Phones — fetch ALL records once per file selection or search change; page/limit handled client-side
  useEffect(() => {
    if (value !== 2) return;
    setAllPhoneNumbers([]);
    if (selectedFileViewName) {
      fetchBlackListedData("phones", selectedFileViewName);
    } else {
      fetchBlackListedData("phones");
    }
  }, [value, selectedFileViewName, searchPhone]);

  // LinkedIn — fetch ALL records once per file selection or search change; page/limit handled client-side
  useEffect(() => {
    if (value !== 3) return;
    setAllLinkedInProfiles([]);
    if (selectedFileViewName) {
      fetchBlackListedData("linkedins", selectedFileViewName);
    } else {
      fetchBlackListedData("linkedins");
    }
  }, [value, selectedFileViewName, searchLinkedIn]);

  const phonePaginatedData = {
    data: allPhoneNumbers.slice((page - 1) * limit, page * limit),
    total: allPhoneNumbers.length,
  };
  const linkedInPaginatedData = {
    data: allLinkedInProfiles.slice((page - 1) * limit, page * limit),
    total: allLinkedInProfiles.length,
  };
  const paginatedData = value === 1 ? blockedDomains : value === 2 ? phonePaginatedData : value === 3 ? linkedInPaginatedData : blockedEmails;
  const pageCount = Math.ceil(paginatedData?.total / limit);

  const activeSelectedDataLabel =
    value === 1
      ? (isSelectAllDomainsEnabled
        ? paginatedData?.total
        : activeSelectedData?.length) > 1
        ? "Domains"
        : "Domain"
      : value === 2
        ? (isSelectAllPhonesEnabled
          ? paginatedData?.total
          : activeSelectedData?.length) > 1
          ? "Phone Numbers"
          : "Phone Number"
        : value === 3
          ? (isSelectAllLinkedInsEnabled
            ? paginatedData?.total
            : activeSelectedData?.length) > 1
            ? "LinkedIn Profiles"
            : "LinkedIn Profile"
          : (isSelectAllEmailsEnabled
            ? paginatedData?.total
            : activeSelectedData?.length) > 1
            ? "Emails"
            : "Email";

  return (
    <>
      <Card sx={{ height: "100%", overflow: "hidden", border: "1px solid #EAECF0", borderRadius: "8px" }} className="glass-wrapper">
        <CardContent
          sx={{
            p: 1,
            height: "100%",
            pb: "8px !important",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          }}>
          <div
            // ref={section9Ref}
            id="section9"
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "6px",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box>
                {!selectedFileViewData && (
                  <Select
                    value={value}
                    onChange={(e) => handleChange(e, e.target.value)}
                    size="small"
                    variant="outlined"
                    className="glass-dropdown"
                    sx={{
                      minWidth: 180,
                      fontWeight: 700,
                      fontSize: "14px",
                      "& .MuiSelect-select": { py: "6px" },
                    }}
                  >
                    <MenuItem value={0}>Emails</MenuItem>
                    <MenuItem value={1}>Domains</MenuItem>
                    <MenuItem value={2}>Phones</MenuItem>
                    <MenuItem value={3}>LinkedIn</MenuItem>
                  </Select>
                )}

                {/* new */}
                {selectedFileViewData && (

                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ alignItems: "center", justifyContent: "space-between" }}

                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setSelectedFileViewData(false);
                        setSelectedFileViewName("");
                        setPage(1);
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        cursor: "pointer",
                      }}
                      className="glass-button-secondary-50"
                    >
                      <ArrowBackIcon />
                      Back
                    </Button>
                    <ControlledInput
                      label={
                        value === 1 ? "Search By Domain"
                          : value === 2 ? "Search By Phone"
                            : value === 3 ? "Search By LinkedIn"
                              : "Search By Email"
                      }
                      search={
                        value === 1 ? searchDomain
                          : value === 2 ? searchPhone
                            : value === 3 ? searchLinkedIn
                              : searchEmail
                      }
                      setSearch={
                        value === 1 ? setSearchDomain
                          : value === 2 ? setSearchPhone
                            : value === 3 ? setSearchLinkedIn
                              : setSearchEmail
                      }
                      setPage={setPage}
                      value={value}
                    />
                  </Stack>)}

              </Box>
              {/* <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: theme.palette.text.primary,
                }}
              >
                Block List
              </Typography> */}
              <Stack
                direction="row"
                justifyContent="end"
                alignItems="center"
                spacing={2}
              >
                {!selectedFileViewData && value !== 2 && value !== 3 && (
                  <Stack direction="row" justifyContent="end">
                    <Button
                      variant="contained"
                      sx={{ fontSize: "14px" }}
                      onClick={() => {
                        setSelectedFileViewName("All");
                        setSelectedFileViewData(true);
                      }}
                    >
                      View All {value === 1 ? "Domains" : "Emails"}
                    </Button>
                  </Stack>
                )}
                {!selectedFileViewData && value === 2 && (
                  <Stack direction="row" justifyContent="end">
                    <Button
                      variant="contained"
                      sx={{ fontSize: "14px" }}
                      onClick={() => {
                        setPage(1);
                        setSelectedFileViewName("All");
                        setSelectedFileViewData(true);
                      }}
                    >
                      View All Phone Numbers
                    </Button>
                  </Stack>
                )}
                {!selectedFileViewData && value === 3 && (
                  <Stack direction="row" justifyContent="end">
                    <Button
                      variant="contained"
                      sx={{ fontSize: "14px" }}
                      onClick={() => {
                        setPage(1);
                        setSelectedFileViewName("All");
                        setSelectedFileViewData(true);
                      }}
                    >
                      View All LinkedIn Profiles
                    </Button>
                  </Stack>
                )}
                <Button
                  variant="contained"
                  onClick={handleClickOpenImportLeadsDialog}
                  sx={{ fontSize: '14px' }}
                >
                  Import {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}
                </Button>
              </Stack>
            </Box>
            <Divider />
            {/* <Box
              sx={{
                textAlign: "left",
                mt: 1,
                ml: 1,
                mb: 0.5
              }}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: (theme) => theme.palette.text.secondary,
                  lineHeight: "18px",
                  display: "inline",
                }}
              >
                What’s the Block List? Exclude unwanted contacts.{" "}
                <Link
                  href={`${HELP_URL}/11905179-block-list`}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: "13px",
                    fontWeight: 600,
                    lineHeight: "18px",
                    color: (theme) => theme.palette.primary.main,
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                    display: "inline",
                  }}
                >
                  [Learn more]
                </Link>
              </Typography>
            </Box> */}
            <HelperLink
              helperText={"What’s the Block List? Exclude unwanted contacts. "}
              actionText={"Learn more"}
              style={{
                textAlign: "left",
                mt: 1,
                ml: 1,
                mb: 0.5
              }}
            />

            <Box
              sx={{ flex: 1, minHeight: 0 }} component={Scrollbar}
            >

              {selectedFileViewData && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: 1,
                    gap: 2,
                  }}

                >
                  {/* <Stack
                    direction="row"
                    spacing={2}
                    sx={{ alignItems: "center" }}
                  >
                    <div
                      onClick={() => setSelectedFileViewName(undefined)}
                      style={{ cursor: "pointer" }}
                    >
                      <ArrowBackIcon />
                    </div>
                    <Button
                      variant="outlined"
                      onClick={() => setSelectedFileViewName(undefined)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        cursor: "pointer",
                      }}
                      className="glass-button-secondary-50"
                    >
                      <ArrowBackIcon />
                       Back
                    </Button>
                    <ControlledInput
                      label={
                        value === 1 ? "Search By Domain"
                        : value === 2 ? "Search By Phone"
                        : value === 3 ? "Search By LinkedIn"
                        : "Search By Email"
                      }
                      search={
                        value === 1 ? searchDomain
                        : value === 2 ? searchPhone
                        : value === 3 ? searchLinkedIn
                        : searchEmail
                      }
                      setSearch={
                        value === 1 ? setSearchDomain
                        : value === 2 ? setSearchPhone
                        : value === 3 ? setSearchLinkedIn
                        : setSearchEmail
                      }
                      setPage={setPage}
                      value={value}
                    />
                  </Stack> */}

                  {/* <TextField
                  placeholder={
                    value === 1 ? "Search by domain" : "Search by email"
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlined sx={{ ml: "5px" }} />
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  sx={{
                    width: { xs: "80%", md: 300 },
                    height: 40,
                    backgroundColor: "white",
                    "& div": { pl: 0.3 },
                    "& div fieldset": {
                      borderRadius: "8px",
                      border: "1px solid #E4E4E5",
                    },
                    "& div input": {
                      py: 1.3,
                      fontSize: "13px",
                      fontWeight: 400,
                      lineHeight: "16px",
                      letterSpacing: "0em",
                      "&::placeholder": {
                        color: "rgba(40, 40, 123, 0.5)",
                      },
                    },
                  }}
                  value={value === 1 ? searchDomain : searchEmail}
                  onChange={(e) => {
                    if (value === 1) {
                      setSearchDomain(e.target.value);
                    } else {
                      setSearchEmail(e.target.value);
                    }
                  }}
                /> */}
                  {(activeSelectedData?.length > 0 ||
                    (value === 0 && isSelectAllEmailsEnabled) ||
                    (value === 1 && isSelectAllDomainsEnabled) ||
                    (value === 2 && isSelectAllPhonesEnabled) ||
                    (value === 3 && isSelectAllLinkedInsEnabled)) && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <Typography sx={{ color: theme.palette.text.primary }}>
                          {`${(value === 0 && isSelectAllEmailsEnabled) ||
                            (value === 1 && isSelectAllDomainsEnabled) ||
                            (value === 2 && isSelectAllPhonesEnabled) ||
                            (value === 3 && isSelectAllLinkedInsEnabled)
                            ? paginatedData?.total
                            : activeSelectedData?.length
                            } ${activeSelectedDataLabel}`}{" "}
                          Selected
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="error"
                            sx={{ borderRadius: 1 }}
                            onClick={handleClickOpen}
                            size="small"
                          >
                            Delete
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ borderRadius: 1 }}
                            onClick={handleClear}
                            size="small"
                          >
                            Clear
                          </Button>
                        </Box>
                      </Box>
                    )}
                </Box>
              )}

              <TabPanel value={value} index={0}>
                {selectedFileViewData ? (
                  <BlackListPanel
                    data={blockedEmails?.data}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedEmails}
                    setSelected={setSelectedEmails}
                    isSelectAllEnabled={isSelectAllEmailsEnabled}
                    setIsSelectAllEnabled={setIsSelectAllEmailsEnabled}
                  />
                ) : (
                  <BlackListFilesPanel
                    data={emailFiles}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedEmails}
                    setSelected={setSelectedEmails}
                    setSelectedFileViewName={setSelectedFileViewName}
                    setSelectedFileViewData={setSelectedFileViewData}
                    fetchBlackListedData={fetchBlackListedData}
                    userEmail={userEmail}
                  />
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                {selectedFileViewData ? (
                  <BlackListPanel
                    data={blockedDomains?.data}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedDomains}
                    setSelected={setSelectedDomains}
                    isSelectAllEnabled={isSelectAllDomainsEnabled}
                    setIsSelectAllEnabled={setIsSelectAllDomainsEnabled}
                  />
                ) : (
                  <BlackListFilesPanel
                    data={domainFiles}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedEmails}
                    setSelected={setSelectedEmails}
                    setSelectedFileViewName={setSelectedFileViewName}
                    setSelectedFileViewData={setSelectedFileViewData}
                    fetchBlackListedData={fetchBlackListedData}
                    userEmail={userEmail}
                  />
                )}
              </TabPanel>
              <TabPanel value={value} index={2}>
                {selectedFileViewData ? (
                  <BlackListPanel
                    data={phonePaginatedData.data}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedPhones}
                    setSelected={setSelectedPhones}
                    isSelectAllEnabled={isSelectAllPhonesEnabled}
                    setIsSelectAllEnabled={setIsSelectAllPhonesEnabled}
                  />
                ) : (
                  <PhoneFilesPanel
                    data={phoneFiles}
                    isLoading={isLoading}
                    setSelectedFileViewName={setSelectedFileViewName}
                    setSelectedFileViewData={setSelectedFileViewData}
                    setPage={setPage}
                    fetchBlackListedData={fetchBlackListedData}
                    type="phones"
                    typeName="Phone Numbers"
                  />
                )}
              </TabPanel>
              <TabPanel value={value} index={3}>
                {selectedFileViewData ? (
                  <BlackListPanel
                    data={linkedInPaginatedData.data}
                    isLoading={isLoading}
                    value={value}
                    selected={selectedLinkedIns}
                    setSelected={setSelectedLinkedIns}
                    isSelectAllEnabled={isSelectAllLinkedInsEnabled}
                    setIsSelectAllEnabled={setIsSelectAllLinkedInsEnabled}
                  />
                ) : (
                  <PhoneFilesPanel
                    data={linkedInFiles}
                    isLoading={isLoading}
                    setSelectedFileViewName={setSelectedFileViewName}
                    setSelectedFileViewData={setSelectedFileViewData}
                    setPage={setPage}
                    fetchBlackListedData={fetchBlackListedData}
                    type="linkedins"
                    typeName="LinkedIn Profiles"
                  />
                )}
              </TabPanel>
            </Box>
            {selectedFileViewData && paginatedData?.total > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Pagination
                  count={pageCount}
                  page={page}
                  onChange={handlePageChange}
                  variant="outlined"
                  shape="rounded"
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: 3,
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  <Typography sx={{ color: theme => theme.palette.text.primary }}>
                    Total {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}:{" "}
                    <b>{paginatedData?.total || 0}</b>
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: 1,
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Typography sx={{ fontSize: "14px", fontWeight: "500", color: theme => theme.palette.text.primary }}>
                      Rows per page
                    </Typography>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={limit}
                      //label="Rows per page"
                      onChange={handleLimitChange}
                      size="small"
                      sx={{
                        "& .MuiSelect-select": { width: "30px", py: "4px" },
                      }}
                      className="glass-dropdown"
                      variant="outlined"
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </Box>
                </Box>
              </Box>
            )}
          </div>
        </CardContent>
      </Card>
      <Dialog
        open={isImportLeadsDialogOpen}
        onClose={handleCloseOpenImportLeadsDialog}
        maxWidth="md"
        sx={{
          backgroundColor: "rgba(4, 4, 30, 0.5)",
          "& .MuiDialog-paper": {
            minWidth: "300px",
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    lineHeight: "28px",
                    color: theme => theme.palette.text.primary
                  }}
                >
                  Import {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"}
                </Typography>
                {activeStep !== 0 && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 0.5,
                      }}

                    >
                      <ArrowRight />
                    </Box>
                  </>
                )}
                {activeStep === 1 ? (
                  <>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "28px",
                        color: theme.palette.text.secondary,
                      }}
                    >
                      Import CSV File
                    </Typography>
                  </>
                ) : activeStep === 2 ? (
                  <>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        lineHeight: "28px",
                        color: theme.palette.text.secondary,
                      }}
                    >
                      Input Emails Manually
                    </Typography>
                  </>
                ) : null}
              </Box>

              {activeStep === 0 ? (
                <>
                  {/* <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 400,
                      lineHeight: "20px",
                      color: "#8181B0",
                      mt: 1,
                    }}
                  >
                    Choose one of the methods listed below to effortlessly
                    import {value === 1 ? "domains" : "emails"}.
                  </Typography> */}
                </>
              ) : (
                <>
                  {/* <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 400,
                      lineHeight: "20px",
                      color: "#8181B0",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setActiveStep(0);
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mr: 1,
                      }}
                    >
                      <ArrowLeft color="#8181B0" />
                    </Box>
                    Select a Different Method
                  </Typography> */}
                </>
              )}
            </Box>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={handleCloseOpenImportLeadsDialog}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {activeStep === 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "100%",
                    p: 3,
                    border: "1px solid #00AA38",
                    flexDirection: "column",
                    height: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0px 12px 15px 0px #4B71970D",
                  }}
                  className="glass-wrapper-50"
                  onClick={() => {
                    setActiveStep(1);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <BulkUploadIcon /> */}
                    <UploadFileOutlined />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        lineHeight: "26px",
                        color: theme.palette.text.primary,
                        mt: 1.5,
                      }}
                    >
                      Upload CSV
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "none", // "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    cursor: "pointer",
                    width: "100%",
                    p: 3,
                    border: "1px solid #CECECE",
                    flexDirection: "column",
                    height: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0px 12px 15px 0px #4B71970D",
                    mx: 2,
                  }}
                  onClick={() => {
                    setActiveStep(2);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {/* <ManualEmailIcon /> */}
                    <EmailOutlined />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        lineHeight: "26px",
                        color: "#28287B",
                        mt: 1.5,
                      }}
                    >
                      Enter {value === 1 ? "Domains" : value === 2 ? "Phone Numbers" : value === 3 ? "LinkedIn Profiles" : "Emails"} Manually
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </>
          ) : activeStep === 1 ? (
            <CsvImport
              setIsImportLeadsDialogOpen={setIsImportLeadsDialogOpen}
              onClose={handleCloseOpenImportLeadsDialog}
              selectedFile={
                value === 1 ? selectedDomainFile : selectedEmailFile
              }
              setSelectedFile={
                value === 1 ? setSelectedDomainFile : setSelectedEmailFile
              }
              fileInputKey={fileInputKey}
              value={value}
              userEmail={userEmail}
              fetchBlackListedData={fetchBlackListedData}
            />
          ) : null}
        </DialogContent>
      </Dialog>
      <Dialog
        open={isDeleteOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              color: "red",
            }}
          >
            <ReportProblemOutlined sx={{ mr: 1 }} />
            Delete {activeTab}
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: theme.palette.text.primary }}>
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "16px", color: theme.palette.text.primary }}
          >
            {`${(value === 0 && isSelectAllEmailsEnabled) ||
              (value === 1 && isSelectAllDomainsEnabled) ||
              (value === 2 && isSelectAllPhonesEnabled) ||
              (value === 3 && isSelectAllLinkedInsEnabled)
              ? paginatedData?.total
              : activeSelectedData?.length
              } ${activeSelectedDataLabel} ${((value === 0 && isSelectAllEmailsEnabled) ||
                (value === 1 && isSelectAllDomainsEnabled) ||
                (value === 2 && isSelectAllPhonesEnabled) ||
                (value === 3 && isSelectAllLinkedInsEnabled)
                ? paginatedData?.total
                : activeSelectedData?.length) > 1
                ? "have"
                : "has"
              } been selected`}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "16px", color: theme.palette.text.primary }}
          >
            Are you sure you want to permanently delete{" "}
            {((value === 0 && isSelectAllEmailsEnabled) ||
              (value === 1 && isSelectAllDomainsEnabled) ||
              (value === 2 && isSelectAllPhonesEnabled) ||
              (value === 3 && isSelectAllLinkedInsEnabled)
              ? paginatedData?.total
              : activeSelectedData?.length) > 1
              ? "them"
              : "it"}
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ borderRadius: 1 }}
            onClick={handleClose}
            variant="outlined"
            className="glass-button-secondary-50"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              borderRadius: 1,
              backgroundColor: "red",
              "&:hover": { backgroundColor: "#e30000" },
            }}
            onClick={handleDelete}
            autoFocus
            disabled={isDeleting}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BlackList;
